export const easeTimes = {
	slow: 500,
	medium: 300,
	fast: 150
}
